import { render, staticRenderFns } from "./AllocationUnitDetails.vue?vue&type=template&id=55f14a7d&"
import script from "./AllocationUnitDetails.vue?vue&type=script&lang=js&"
export * from "./AllocationUnitDetails.vue?vue&type=script&lang=js&"
import style0 from "./AllocationUnitDetails.vue?vue&type=style&index=0&id=55f14a7d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports